import script from "./breaks.vue?vue&type=script&setup=true&lang=ts"
export * from "./breaks.vue?vue&type=script&setup=true&lang=ts"

import "./breaks.vue?vue&type=style&index=0&id=030145e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030145e6"]])

export default __exports__